import { Injectable, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SegmentValidationItem } from './segment-validation-item.interface';
import { validationStub } from './segment-validation-stub';
import { getValidationByKey, getValidationByName } from '../validation-helpers';

@Injectable()
export class SegmentValidationService {

  model: {
    data: SegmentValidationItem[],
    errorDetail: string;
  } = {
    data: [],
    errorDetail: '',
  };

  setDataEvent: EventEmitter<any> = new EventEmitter<any>();

  public setData(data?: SegmentValidationItem[], errorDetail?: string): void {
    this.model.data = data || [];
    this.model.errorDetail = errorDetail || '';
    _.forEach(this.model.data, (item: any) => {
      const validationItem: any = item.key ?
        getValidationByKey(item.key) :
        getValidationByName(item.name);
      item.title = (validationItem && validationItem.title) ? validationItem.title : '';
    });
    this._emit();
  }

  public resetValidation() {
    this.setData();
  }

  public formatValidationTypes(data: any) {
    _.each(validationStub, (stub) => {
      if (_.has(data, stub.key)) {
        if (data[stub.key].length) {
          stub.valid = false;
        } else {
          stub.valid = true;
        }
      }
      return stub;
    });

    return validationStub;
  }

  private _emit(): void {
    this.setDataEvent.emit(this.model);
  }

}
